export enum ChangeState {
    Unchanged = 0,
    New = 1,
    Modified = 2,
    Deleted = 9
}
